<mat-form-field>
    @if (label()) {
        <mat-label>{{label()}}</mat-label>
    }
    <input matInput
           #input
           [autofocus]="autofocus()"
           [type]="getType()"
           [placeholder]="placeholder()"
           [formField]="formField()">
    <mat-icon matSuffix
              (click)="toggleVisibility()"
              [title]="getTooltip()">{{getIcon()}}</mat-icon>
    @if (hint()) {
        <mat-hint>{{hint()}}</mat-hint>
    }
    <mat-error><app-field-errors [formField]="formField()"></app-field-errors></mat-error>
</mat-form-field>
